import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ImageProcessorConfig, defaultConfig } from './models';
import { transform } from './image.util';
import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { ImageConfigService } from './services/image-config.service';
import { ImageConfig } from './models/image-config.model';

export function ProvideOptimisedImageProcessor(
  config: Partial<ImageProcessorConfig>,
  additionalConfig: Partial<ImageConfig>
): EnvironmentProviders {
  // using default values for missing properties
  const merged: ImageProcessorConfig = {
    ...defaultConfig,
    ...config,
  } as ImageProcessorConfig;

  const merged2: ImageConfig = {
    placeholderUrl: 'https://www.teamfoster.nl/media/uploads/Placeholder_view_vector.svg',
    defaultFormat: 'webp',
    ...additionalConfig,
  };

  return makeEnvironmentProviders([
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig, b: any) => {
        return transform(config, merged);
      },
    },
    {
      provide: ImageProcessorConfig,
      useValue: merged,
    },
    {
      provide: ImageConfigService,
      useValue: merged2,
    },
  ]);
}

export function ProvideImageProcessor(config: Partial<ImageProcessorConfig>, additionalConfig: Partial<ImageConfig>): EnvironmentProviders {
  // using default values for missing properties
  const merged = { ...defaultConfig, ...config };

  return makeEnvironmentProviders([
    {
      provide: ImageProcessorConfig,
      useValue: merged,
    },
    ProvideOptimisedImageProcessor({}, {}),
  ]);
}
